<template>
  <div v-if="open" class="olimpiadas-modal">
    <div class="olimpiadas-modal__backdrop" @click="onClose"></div>
    <div class="olimpiadas-modal__content">
      <h3>Ya estás inscrito</h3>
      <p>
        Ahora puedes prepararte usando el curso de Olimpiadas 2026.
      </p>
      <p class="olimpiadas-modal__hint">Busca este curso en tu dashboard:</p>
      <img
        src="/images/olimpiadas-2026-course-card.png"
        alt="Curso Olimpiadas 2026 en el dashboard"
        class="olimpiadas-modal__card-img"
      />
      <button class="olimpiadas-modal__button" @click="onClose">
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OlimpiadasRegistrationModal",
  props: {
    open: Boolean,
  },
  emits: ["close"],
  methods: {
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.olimpiadas-modal {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
}

.olimpiadas-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 18, 28, 0.5);
}

.olimpiadas-modal__content {
  position: relative;
  z-index: 1;
  width: min(420px, 90vw);
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 24px 48px rgba(23, 30, 52, 0.2);
}

.olimpiadas-modal__content h3 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #121826;
}

.olimpiadas-modal__content p {
  color: #5b6476;
  font-size: 14px;
  margin-bottom: 20px;
}

.olimpiadas-modal__hint {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 10px !important;
}

.olimpiadas-modal__card-img {
  display: block;
  width: 100%;
  max-width: 280px;
  height: auto;
  margin: 0 auto 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

</style>
